import { api } from '@bilibili-maoer/web-utils';
import qs from 'qs';
import { postFetch } from '../../utils/fetcher.js';
import '@babel/runtime-corejs3/core-js/instance/concat';

var loginViaSMS = function loginViaSMS(body) {
  return postFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/account/smslogin"),
    body: qs.stringify(body)
  });
};

export { loginViaSMS };
